<template>
  <div class="menu">
    <div @click="showDropdown = false" class="menu-content">
      <img class="img-logo" src="@/assets/bg1.png" alt="Logo" />
      <router-link
        to="/"
        v-if="user.dash_vis"
        :class="routerName === 'home' ? 'active-route' : ''"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
        >
          <path
            d="M1.78552 7.8407H19.7855M7.78552 19.8407V7.8407M3.78552 1.8407H17.7855C18.8901 1.8407 19.7855 2.73613 19.7855 3.8407V17.8407C19.7855 18.9453 18.8901 19.8407 17.7855 19.8407H3.78552C2.68095 19.8407 1.78552 18.9453 1.78552 17.8407V3.8407C1.78552 2.73613 2.68095 1.8407 3.78552 1.8407Z"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>Dashboard</span>
      </router-link>
      
      <router-link
        to="/nfse"
        v-if="user.nfse_vis"
        :class="routerName === 'nfse' ? 'active-route' : ''"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="22"
          viewBox="0 0 18 22"
          fill="none"
        >
          <path
            d="M11 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V7M11 1L17 7M11 1V7H17M13 12H5M13 16H5M7 8H5"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>NFS-e</span>
      </router-link>

      <router-link
        to="/produto"
        v-if="user.pro_vis"
        :class="routerName === 'produto' ? 'active-route' : ''"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="23"
          viewBox="0 0 21 23"
          fill="none"
        >
          <path
            d="M14.7704 8.86829L5.77039 3.67829M1.54039 6.42829L10.2704 11.4783L19.0004 6.42829M10.2704 21.5483V11.4683M19.2704 15.4683V7.46829C19.27 7.11756 19.1774 6.7731 19.0019 6.46945C18.8264 6.1658 18.5741 5.91365 18.2704 5.73829L11.2704 1.73829C10.9663 1.56275 10.6215 1.47034 10.2704 1.47034C9.91931 1.47034 9.57442 1.56275 9.27039 1.73829L2.27039 5.73829C1.96665 5.91365 1.71437 6.1658 1.53885 6.46945C1.36333 6.7731 1.27075 7.11756 1.27039 7.46829V15.4683C1.27075 15.819 1.36333 16.1635 1.53885 16.4671C1.71437 16.7708 1.96665 17.0229 2.27039 17.1983L9.27039 21.1983C9.57442 21.3738 9.91931 21.4662 10.2704 21.4662C10.6215 21.4662 10.9663 21.3738 11.2704 21.1983L18.2704 17.1983C18.5741 17.0229 18.8264 16.7708 19.0019 16.4671C19.1774 16.1635 19.27 15.819 19.2704 15.4683Z"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>Produtos</span>
      </router-link>

      <router-link
        to="/empresa"
        v-if="user.emp_vis"
        :class="routerName === 'empresa' ? 'active-route' : ''"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="20"
          viewBox="0 0 22 20"
          fill="none"
        >
          <path
            d="M15 19V3C15 2.46957 14.7893 1.96086 14.4142 1.58579C14.0391 1.21071 13.5304 1 13 1H9C8.46957 1 7.96086 1.21071 7.58579 1.58579C7.21071 1.96086 7 2.46957 7 3V19M3 5H19C20.1046 5 21 5.89543 21 7V17C21 18.1046 20.1046 19 19 19H3C1.89543 19 1 18.1046 1 17V7C1 5.89543 1.89543 5 3 5Z"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>Empresas</span>
      </router-link>

      <router-link
        to="/integracao"
        v-if="user.int_vis"
        :class="routerName === 'integracao' ? 'active-route' : ''"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#009488"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-triangle"
        >
          <path
            d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
          />
        </svg>
        <span>Integrações</span>
      </router-link>

      <router-link
        to="/importacao"
        v-if="user.imp_vis"
        :class="routerName === 'importacao' ? 'active-route' : ''"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17 8 12 3 7 8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </svg>
        <span>Importação</span>
      </router-link>

      <router-link
        to="/cliente"
        v-if="user.cli_vis"
        :class="routerName === 'cliente' ? 'active-route' : ''"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        <span>Clientes</span>
      </router-link>

      <router-link
        to="/faturamento"
        v-if="user.fat_vis"
        :class="routerName === 'faturamento' ? 'active-route' : ''"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span>Faturamentos</span>
      </router-link>

      <router-link
        to="/usuario"
        v-if="user.admin"
        :class="routerName === 'usuario' ? 'active-route' : ''"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="2119"
          height="21"
          viewBox="0 0 19 21"
          fill="none"
        >
          <path
            d="M17.701 19.365V17.365C17.701 16.3041 17.2796 15.2867 16.5295 14.5366C15.7793 13.7864 14.7619 13.365 13.701 13.365H5.70105C4.64018 13.365 3.62277 13.7864 2.87262 14.5366C2.12248 15.2867 1.70105 16.3041 1.70105 17.365V19.365M13.701 5.36499C13.701 7.57413 11.9102 9.36499 9.70105 9.36499C7.49191 9.36499 5.70105 7.57413 5.70105 5.36499C5.70105 3.15585 7.49191 1.36499 9.70105 1.36499C11.9102 1.36499 13.701 3.15585 13.701 5.36499Z"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>Usuários</span>
      </router-link>

      <div class="user-button">
        <div class="user-dropdown-img">
          <Gravatar :email="user.email" alt="Usuário" />
        </div>
        <span>{{ user.name }}</span>
        <svg @click.stop.prevent="showDropdown = !showDropdown" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
          <path d="M12.764 15.0511C14.4209 15.0511 15.764 13.708 15.764 12.0511C15.764 10.3943 14.4209 9.05115 12.764 9.05115C11.1072 9.05115 9.76404 10.3943 9.76404 12.0511C9.76404 13.708 11.1072 15.0511 12.764 15.0511Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20.164 15.0511C20.0309 15.3528 19.9912 15.6873 20.05 16.0117C20.1089 16.3361 20.2635 16.6355 20.494 16.8711L20.554 16.9311C20.74 17.1169 20.8875 17.3375 20.9882 17.5803C21.0888 17.8231 21.1406 18.0833 21.1406 18.3461C21.1406 18.609 21.0888 18.8692 20.9882 19.112C20.8875 19.3548 20.74 19.5754 20.554 19.7611C20.3683 19.9471 20.1477 20.0946 19.9049 20.1953C19.6621 20.2959 19.4019 20.3477 19.139 20.3477C18.8762 20.3477 18.616 20.2959 18.3732 20.1953C18.1304 20.0946 17.9098 19.9471 17.724 19.7611L17.664 19.7011C17.4284 19.4706 17.129 19.316 16.8046 19.2571C16.4802 19.1983 16.1457 19.238 15.844 19.3711C15.5483 19.4979 15.296 19.7084 15.1183 19.9767C14.9407 20.245 14.8453 20.5594 14.844 20.8811V21.0511C14.844 21.5816 14.6333 22.0903 14.2583 22.4654C13.8832 22.8404 13.3745 23.0511 12.844 23.0511C12.3136 23.0511 11.8049 22.8404 11.4298 22.4654C11.0548 22.0903 10.844 21.5816 10.844 21.0511V20.9611C10.8363 20.6302 10.7292 20.3091 10.5365 20.0398C10.3439 19.7706 10.0748 19.5654 9.76404 19.4511C9.46242 19.318 9.12784 19.2783 8.80345 19.3371C8.47905 19.396 8.17972 19.5506 7.94404 19.7811L7.88404 19.8411C7.69829 20.0271 7.47771 20.1746 7.23492 20.2753C6.99212 20.3759 6.73187 20.4277 6.46904 20.4277C6.20621 20.4277 5.94595 20.3759 5.70316 20.2753C5.46036 20.1746 5.23978 20.0271 5.05404 19.8411C4.86809 19.6554 4.72057 19.4348 4.61992 19.192C4.51927 18.9492 4.46746 18.689 4.46746 18.4261C4.46746 18.1633 4.51927 17.9031 4.61992 17.6603C4.72057 17.4175 4.86809 17.1969 5.05404 17.0111L5.11404 16.9511C5.34457 16.7155 5.49922 16.4161 5.55804 16.0917C5.61686 15.7673 5.57715 15.4328 5.44404 15.1311C5.31728 14.8354 5.10679 14.5831 4.8385 14.4055C4.57021 14.2278 4.25582 14.1324 3.93404 14.1311H3.76404C3.23361 14.1311 2.7249 13.9204 2.34982 13.5454C1.97475 13.1703 1.76404 12.6616 1.76404 12.1311C1.76404 11.6007 1.97475 11.092 2.34982 10.7169C2.7249 10.3419 3.23361 10.1311 3.76404 10.1311H3.85404C4.18503 10.1234 4.50604 10.0163 4.77534 9.82366C5.04463 9.63105 5.24975 9.36188 5.36404 9.05115C5.49715 8.74953 5.53686 8.41495 5.47804 8.09056C5.41922 7.76616 5.26457 7.46683 5.03404 7.23115L4.97404 7.17115C4.78809 6.9854 4.64057 6.76482 4.53992 6.52203C4.43927 6.27923 4.38746 6.01898 4.38746 5.75615C4.38746 5.49332 4.43927 5.23306 4.53992 4.99027C4.64057 4.74747 4.78809 4.52689 4.97404 4.34115C5.15978 4.15519 5.38036 4.00768 5.62316 3.90703C5.86595 3.80638 6.12621 3.75457 6.38904 3.75457C6.65187 3.75457 6.91212 3.80638 7.15492 3.90703C7.39771 4.00768 7.61829 4.15519 7.80404 4.34115L7.86404 4.40115C8.09972 4.63168 8.39905 4.78633 8.72345 4.84515C9.04784 4.90397 9.38242 4.86426 9.68404 4.73115H9.76404C10.0598 4.60438 10.3121 4.3939 10.4897 4.12561C10.6674 3.85732 10.7628 3.54293 10.764 3.22115V3.05115C10.764 2.52071 10.9748 2.01201 11.3498 1.63693C11.7249 1.26186 12.2336 1.05115 12.764 1.05115C13.2945 1.05115 13.8032 1.26186 14.1783 1.63693C14.5533 2.01201 14.764 2.52071 14.764 3.05115V3.14115C14.7653 3.46293 14.8607 3.77732 15.0383 4.04561C15.216 4.3139 15.4683 4.52438 15.764 4.65115C16.0657 4.78426 16.4002 4.82397 16.7246 4.76515C17.049 4.70633 17.3484 4.55168 17.584 4.32115L17.644 4.26115C17.8298 4.07519 18.0504 3.92768 18.2932 3.82703C18.536 3.72638 18.7962 3.67457 19.059 3.67457C19.3219 3.67457 19.5821 3.72638 19.8249 3.82703C20.0677 3.92768 20.2883 4.07519 20.474 4.26115C20.66 4.44689 20.8075 4.66747 20.9082 4.91027C21.0088 5.15306 21.0606 5.41332 21.0606 5.67615C21.0606 5.93898 21.0088 6.19923 20.9082 6.44203C20.8075 6.68482 20.66 6.9054 20.474 7.09115L20.414 7.15115C20.1835 7.38683 20.0289 7.68616 19.97 8.01056C19.9112 8.33495 19.9509 8.66953 20.084 8.97115V9.05115C20.2108 9.34692 20.4213 9.59916 20.6896 9.77684C20.9579 9.95452 21.2723 10.0499 21.594 10.0511H21.764C22.2945 10.0511 22.8032 10.2619 23.1783 10.6369C23.5533 11.012 23.764 11.5207 23.764 12.0511C23.764 12.5816 23.5533 13.0903 23.1783 13.4654C22.8032 13.8404 22.2945 14.0511 21.764 14.0511H21.674C21.3523 14.0524 21.0379 14.1478 20.7696 14.3255C20.5013 14.5031 20.2908 14.7554 20.164 15.0511Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <UserDropdown @hideDropdown="showDropdown = false" :showDropdown="showDropdown" />

    <a id="whatsapp-button" target="_blank"
      href="https://api.whatsapp.com/send/?phone=5544999329925&amp;text=Acessei%20o%20Sigame%20e%20tenho%20algumas%20dúvidas.">
      <img src="@/assets/whatsapp-icon.svg" data-lazy-src="@/assets/whatsapp-icon.svg" data-ll-status="loaded" class="entered lazyloaded">
      <noscript>
        <img src="@/assets/whatsapp-icon.svg" />
      </noscript>
    </a>    

  </div>
</template>

<script>
import { mapState } from "vuex";
import Gravatar from 'vue-gravatar'
import UserDropdown from "./UserDropdown.vue";

export default {
  name: "Menu",
  data() {
    return {
      showDropdown: false,
    }
  },
  components: {
    UserDropdown,
    Gravatar
  },
  computed: {
    ...mapState(["user"]),
    routerName() {
      return this.$route.name;
    },
  },
};
</script>

<style scoped>
.user-button {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 300px;
  display: grid;
  grid-template-columns: 100px 120px 80px;
  align-items: center;
  color: #fff;
  font-weight: 100;
  height: fit-content;
  border-top: 1px solid var(--white-medium);
}

.user-button svg {
  margin: 0 auto;
  cursor: pointer;
  pointer-events: all;
  stroke: var(--white-dark);
  transition: .3s;
}

.user-button span {
  color: var(--gray03);
  font-weight: 400;
}

.user-dropdown-img {
  margin: 0px auto;
  padding: 15px 0;
}

.user-dropdown-img > img {
  max-height: 50px;
  border-radius: 50px;
}

#app:has(.modal-backdrop.show) .menu {
  z-index: 0
}
.menu {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  max-width: 100px;
  width: 300px;
  background: white;
  box-shadow: 0px 0 10px #0003;
  z-index: 1;
  transition: max-width 0.3s;
}
.menu:hover {
  max-width: 300px;
}
.menu:hover .menu-content {
  max-width: 300px;
}
.menu-content {
  width: 300px;
  height: 100%;
  overflow: hidden; 
  transition: 0.3s;
  max-width: 100px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.menu a {
  text-decoration: none;
  color: var(--gray03);
  display: grid;
  grid-template-columns: 100px 200px;
  height: 55px;
  align-content: center;
  justify-items: center;
  position: relative;
}
.menu a::after {
  content: "";
  position: absolute;
  height: 7px;
  aspect-ratio: 1;
  border-radius: 50%;
  background-color: transparent;
  transition: 0.3s;
  top: calc(50% - 7px);
  left: 15px;
}
.menu a span {
  display: inline-flex;
  text-align: left;
  width: 100%;
  font-weight: 600;
  font-size: 16px;
  transition: 0.3s;
}
.menu a svg {
  transition: 0.3s;
  stroke: var(--gray03);
}

.menu :is(.active-route, a:hover) :is(svg, span) {
  color: var(--greenn);
  stroke: var(--greenn);
}
.active-route::after {
  background-color: var(--greenn) !important;
}

.menu-itens {
  position: absolute;
  left: 0px;
  background-color: #f9f9f9;
  min-width: 180px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 10px;
  z-index: 1;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  visibility: hidden;
  opacity: 1;
  transition: visibility 0s, opacity 0.5s linear;
}

.menu-itens {
  visibility: visible;
  opacity: 1;
}

.menu-itens a {
  text-decoration: none;
  color: var(--gray03);
  padding: 10px;
}

.menu-itens a:hover {
  text-decoration: none;
  color: var(--gray03);
  background-color: #ededed;
}

.img-logo {
  width: 100px;
  height: 100px;
  padding: 30px;
}

hr {
  border: 0;
  width: 100%;
  height: 1px;
  margin-top: 15px;
  margin-bottom: 20px;
  background-image: linear-gradient(
    to right,
    rgba(120, 120, 120, 0),
    rgba(120, 120, 120, 0.75),
    rgba(120, 120, 120, 0)
  );
}

#whatsapp-button {
  display: flex;
  position: fixed;
  background: #25d366;
  z-index: 99999;
  width: 54px;
  height: 54px;
  right: 30px;
  bottom: 16px!important;
  border-radius: 50%;
  box-shadow: 2px 2px 12px rgba(22, 124, 60, .2);
  transition: .4s;
  align-items: center;
  justify-content: center
}

#whatsapp-button>.rwb-tooltip {
  position: absolute;
  bottom: 100%;
  margin-bottom: 20px;
  border-radius: 4px;
  padding: 15px;
  color: #2d2d2d;
  font-size: 16px;
  white-space: nowrap;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, .2);
  opacity: 0;
  transition: .4s;
  pointer-events: none
}

#whatsapp-button>.rwb-tooltip:after {
  display: block;
  content: "";
  position: absolute;
  top: 85%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 7px 0;
  border-color: #fff transparent transparent transparent;
  transition: .4s
}

#whatsapp-button.left {
  left: 24px
}

#whatsapp-button.left>.rwb-tooltip {
  left: 0;
  transform: translateX(-10%)
}

#whatsapp-button.left>.rwb-tooltip:after {
  left: 23px
}

#whatsapp-button:not(.left)>.rwb-tooltip {
  right: 0;
  transform: translateX(10%)
}

#whatsapp-button:not(.left)>.rwb-tooltip:after {
  right: 23px
}

#whatsapp-button>img {
  display: block;
  width: 34px;
  height: 34px
}

#whatsapp-button:hover {
  background: #21bd5c;
}

#whatsapp-button:hover>.rwb-tooltip {
  opacity: 1;
  transform: translateX(0)
}

#whatsapp-button:hover>.rwb-tooltip:after {
  top: 100%;
  transition-delay: .4s
}

@media (max-width: 768px) {
  .user-button {
    width: 180px;
    grid-template-columns: 65px 80px 35px;
  }
  .user-button svg {
    width: 20px;
    height: 20px;
  }
  .user-dropdown-img > img {
    max-height: 30px;
  }
  .menu{
    max-width: 65px;
  }
  .menu a {
    grid-template-columns: 65px  120px;
    height: 50px; 
  }
  .menu-content {
    max-width: 65px;
  }
  .menu:hover {
    max-width: 180px;
  }
  .menu:hover .menu-content {
    max-width: 180px;
  }
  .img-logo {
    width: 65px;
    height: 65px;
    padding: 15px;
  }
  .menu a::after {
    left: 10px;
  }
}

@media (max-width: 480px) {
  .menu a {
    height: 40px;
  }
  #whatsapp-button {
    bottom: 88px;
    width: 60px;
    height: 60px;
    right: 24px;
  }
}

</style>
